module.exports = __webpack_public_path__ + "static/media/hyundai.9284cb95.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/hyundai.png
// module id = 7368
// module chunks = 4